import { render, staticRenderFns } from "./CompetitionShopAvailability.vue?vue&type=template&id=72744551&scoped=true&"
import script from "./CompetitionShopAvailability.vue?vue&type=script&lang=js&"
export * from "./CompetitionShopAvailability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72744551",
  null
  
)

export default component.exports